import { FolderIcon, RectangleStackIcon } from '@heroicons/react/24/outline';

import useExamWorkspace from '@/data/hook/exam/useExamWorkspace';
import usePedWorkspace from '@/data/hook/ped-content/usePedWorkspace';
import { BreadcrumbItem } from '@/data/hook/useDynamicBreadcrumbItems';
import Activity from '@/models/Activity';
import { mountKey } from '@/utils/courses';
import { ROUTES } from '@/utils/routes';

type UseExamQuestionBreadcrumbProps = {
  activity: Activity;
};

const useExamQuestionBreadcrumb = ({
  activity,
}: UseExamQuestionBreadcrumbProps): BreadcrumbItem[] => {
  const { coursePath, courseLineId, moduleId, slug } = usePedWorkspace();
  const { exam, examId } = useExamWorkspace();

  if (!coursePath || !exam || !slug) return [];

  return [
    {
      id: `coursePath-${slug}`,
      treeKey: mountKey({ type: 'course', id: slug }),
      children: coursePath.course.abbreviation,
      icon: <FolderIcon className="h-4 w-4" />,
      href: ROUTES.ADMIN.COURSE_LINES.PED_CONTENT(courseLineId, moduleId, slug),
    },
    {
      id: `exam-${exam.id}`,
      children: exam.name,
      icon: <FolderIcon className="h-4 w-4" />,
      href: ROUTES.ADMIN.COURSE_LINES.EXAM(
        courseLineId,
        moduleId,
        slug,
        examId,
      ),
    },
    {
      id: `activity-${activity.id}`,
      children: activity.name,
      icon: <RectangleStackIcon className="h-4 w-4" />,
    },
  ];
};

export default useExamQuestionBreadcrumb;
